import DuplicateSpec from "./DuplicateSpec";
export default DuplicateSpec;
